import isBefore from 'date-fns/isBefore';
import parseISO from 'date-fns/parseISO';

const checkGradesReleased = ({ gradesReleasedAt }) =>
  isBefore(parseISO(gradesReleasedAt), new Date());

export default checkGradesReleased;
